var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.2,
    height: 11.38,
    viewBox: "0 0 11.2 11.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "X") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.72,5.69,11,1.36A.8.8,0,1,0,9.83.24L5.6,4.55,1.37.24A.8.8,0,0,0,.23,1.36L4.48,5.69.23,10a.79.79,0,0,0,0,1.13.82.82,0,0,0,.56.23.8.8,0,0,0,.57-.24L5.6,6.83l4.23,4.31a.8.8,0,0,0,.57.24.82.82,0,0,0,.56-.23A.79.79,0,0,0,11,10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.6d72546d29d885734fad2d9954138ddb.svg";
export { ForwardRef as ReactComponent };